export const BackIcon = () => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.53065 10.4691C6.67155 10.61 6.7507 10.8011 6.7507 11.0003C6.7507 11.1996 6.67155 11.3907 6.53065 11.5316C6.38975 11.6725 6.19866 11.7516 5.9994 11.7516C5.80014 11.7516 5.60905 11.6725 5.46815 11.5316L0.46815 6.53157C0.39823 6.4619 0.342752 6.3791 0.304898 6.28794C0.267044 6.19677 0.247559 6.09903 0.247559 6.00032C0.247559 5.90161 0.267044 5.80387 0.304898 5.71271C0.342752 5.62155 0.39823 5.53875 0.46815 5.46907L5.46815 0.469074C5.60905 0.328178 5.80014 0.249023 5.9994 0.249023C6.19866 0.249023 6.38975 0.328178 6.53065 0.469074C6.67155 0.609971 6.7507 0.801067 6.7507 1.00032C6.7507 1.19958 6.67155 1.39068 6.53065 1.53157L2.06252 5.9997L6.53065 10.4691Z" />
    </svg>
  )
}
